export default "__VITE_ASSET__B5Rl6TQ1__"